import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgLogoPiSimple = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 185,
  height: 49,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("path", {
    d: "M160.08 48.61c13.26 0 24-10.752 24-24 0-13.26-10.752-24-24-24-13.249 0-24 10.74-24 24s10.74 24 24 24Z",
    fill: "#511E62"
  }), _jsx("path", {
    d: "M150.503 26.57c1.615-.264 2.566-.596 2.566-.596a27.137 27.137 0 0 0-2.543-.447c.355-.607.653-1.088 1.031-1.638 0 0-1.111.47-1.936 1.088 0 0-.367-.71-.768-1.329 0 0-.194.619-.389 1.661-1.111-.08-1.822-.08-1.822-.08a19.714 19.714 0 0 0 1.169 1.066c-.997.779-1.65 1.546-1.65 1.546.676-.263 1.329-.39 2.005-.584-.08.756-.115 1.558-.103 2.463 0 0 .47-.962 1.249-2.303 1.042.768 2.119 1.455 2.119 1.455a17.293 17.293 0 0 0-.928-2.302ZM149.632 16.82c2.2-.011 3.54-.263 3.54-.263a41.427 41.427 0 0 0-3.253-1.192c.618-.756 1.134-1.374 1.764-2.039 0 0-1.581.413-2.83 1.077 0 0-.309-1.065-.687-2.005 0 0-.412.814-.928 2.211-1.455-.366-2.383-.515-2.383-.515.607.893 1.295 1.73 1.295 1.73-1.513.859-2.544 1.775-2.544 1.775.963-.217 1.845-.24 2.796-.366a31.28 31.28 0 0 0-.745 3.39s.859-1.225 2.211-2.91c1.192 1.296 2.44 2.487 2.44 2.487a27.335 27.335 0 0 0-.676-3.38ZM158.671 12.547c1.192-.046 1.913-.195 1.913-.195a19.013 19.013 0 0 0-1.775-.595c.32-.424.584-.756.928-1.134 0 0-.86.252-1.513.63 0 0-.183-.573-.401-1.077 0 0-.206.447-.469 1.214-.802-.172-1.295-.24-1.295-.24.332.47.733.916.733.916-.802.493-1.351 1.008-1.351 1.008.515-.137.996-.16 1.512-.24a14.63 14.63 0 0 0-.344 1.844s.447-.687 1.157-1.615c.665.687 1.363 1.306 1.363 1.306a24.143 24.143 0 0 0-.458-1.822Z",
    fill: "#FDB913"
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.267 22.079c.091-.298.183-.688.263-1.157l-.011-.035c.091-.63.137-1.271.137-1.924 0-4.09-1.764-7.802-4.64-10.494l-.023-.023a1.14 1.14 0 0 1-.366-.848c0-.653.47-1.294 1.398-1.157h.034c8.351 1.604 14.652 8.89 14.652 17.643 0 9.92-8.099 17.963-18.1 17.963a18.107 18.107 0 0 1-14.172-6.782l-.034-.046a1.146 1.146 0 0 1-.241-.699c0-.642.516-1.157 1.158-1.157.091 0 .171 0 .252.023 1.283.31 2.68.492 4.066.492 2.486 0 4.835-.526 6.931-1.466l.046-.023a.133.133 0 0 0 .017-.007c.105-.048.668-.307 1.117-.004 0 0 .081.057.195.16.665.607 3.059 2.715 5.889 1.26 0 0 .458-.286-.046-.275h-.401a5.451 5.451 0 0 1-1.845-.4 7.042 7.042 0 0 1-1.965-1.18c-.249-.205-.485-.398-.463-.757.034-.16.103-.275.343-.435.112-.077.253-.188.435-.33.116-.09.249-.195.402-.312l.103-.091c.24-.24.24-.493.137-.7-.118-.251-.41-.476-.633-.648a2.22 2.22 0 0 1-.237-.199c-.23-.218-.424-.515-.39-.848.034-.297.241-.538.504-.675.155-.091.375-.197.636-.323l.212-.101c.252-.115.527-.252.813-.401a10.118 10.118 0 0 0 1.604-1.031c.086-.076.171-.145.264-.218l.057-.046c.378-.32.55-.504.79-.767.333-.355.642-.825.871-1.295 0 0 .115-.24.241-.687Zm.71 3.54s.092.973 1.031 1.523c.928.55 1.821.15 1.821.15s1.215-.55.264-.47c-.951.08-1.673-.39-1.673-.39h-.011s-.768-.39-1.157-1.272c-.39-.882-.275.459-.275.459Z",
    fill: "#fff"
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.75 13.623a8.601 8.601 0 0 0-1.27-.084c-.451 0-.958.03-1.27.084-.323.056-.391.199-.391.422V32.66c0 .224.068.366.392.422a8.52 8.52 0 0 0 1.27.085c.453 0 .959-.032 1.27-.085.325-.056.393-.198.393-.422V14.045c0-.223-.069-.367-.394-.422ZM5.058 24.737c-.538 0-.928 0-1.734-.209v-8.28c.645-.11 1.247-.143 1.734-.143 2.547 0 4.036 1.698 4.036 4.208 0 2.6-1.357 4.424-4.036 4.424Zm-.18-11.198c-2.32 0-3.855.259-4.475.373-.324.06-.403.218-.403.441V32.66c0 .224.067.366.392.422.31.054.818.085 1.27.085.452 0 .959-.031 1.27-.085.325-.056.392-.198.392-.422v-5.444c.45.056.955.088 1.568.088 4.063 0 7.557-1.967 7.557-7.108 0-4.406-3.294-6.657-7.57-6.657ZM62.516 18.65a7.25 7.25 0 0 0-1.179-.085c-.452 0-.868.031-1.178.085-.326.055-.393.199-.393.421V32.66c0 .223.067.366.393.422.31.053.726.084 1.178.084a7.3 7.3 0 0 0 1.179-.084c.325-.056.392-.199.392-.422V19.07c0-.222-.067-.366-.392-.42Z",
    fill: "#511E62"
  }), _jsx("mask", {
    id: "logo-pi-simple_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 13,
    width: 5,
    height: 4,
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M59.564 13.345h3.546v3.554h-3.546v-3.554Z",
      fill: "#fff"
    })
  }), _jsx("g", {
    mask: "url(#logo-pi-simple_svg__a)",
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M61.337 13.344c-.98 0-1.773.796-1.773 1.778s.793 1.777 1.773 1.777c.98 0 1.773-.795 1.773-1.777 0-.982-.794-1.778-1.773-1.778Z",
      fill: "#511E62"
    })
  }), _jsx("mask", {
    id: "logo-pi-simple_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 18,
    width: 15,
    height: 16,
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M64.978 18.314h13.126V33.36H64.977V18.314Z",
      fill: "#fff"
    })
  }), _jsx("g", {
    mask: "url(#logo-pi-simple_svg__b)",
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M68.155 24.626c.18-2.407 1.272-3.984 3.424-3.984 2.306 0 3.335 1.728 3.442 3.984h-6.866Zm3.45-6.312c-4.382 0-6.627 3.386-6.627 7.537 0 4.478 2.527 7.51 6.96 7.51 2.28 0 4.109-.898 5.395-2.298.235-.256.153-.594-.043-.813a6.13 6.13 0 0 0-1.07-1.03c-.218-.154-.477-.13-.79.122-1.05.848-2.078 1.315-3.44 1.315-2.507 0-3.619-1.807-3.81-3.847h9.047c.559 0 .876-.273.876-.9 0-4.18-1.68-7.596-6.498-7.596Z",
      fill: "#511E62"
    })
  }), _jsx("mask", {
    id: "logo-pi-simple_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 18,
    width: 14,
    height: 16,
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.465 18.314h13.126V33.36H22.465V18.314Z",
      fill: "#fff"
    })
  }), _jsx("g", {
    mask: "url(#logo-pi-simple_svg__c)",
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.642 24.626c.18-2.407 1.273-3.984 3.425-3.984 2.306 0 3.334 1.728 3.441 3.984h-6.866Zm3.45-6.312c-4.382 0-6.627 3.386-6.627 7.537 0 4.478 2.528 7.51 6.961 7.51 2.28 0 4.108-.898 5.394-2.298.236-.256.153-.594-.043-.813a6.13 6.13 0 0 0-1.07-1.03c-.218-.154-.477-.13-.79.122-1.049.848-2.078 1.315-3.44 1.315-2.507 0-3.618-1.807-3.81-3.847h9.047c.56 0 .877-.273.877-.9 0-4.18-1.68-7.596-6.498-7.596Z",
      fill: "#4D1A5C"
    })
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.301 19.008c-.056-.623-.607-.694-1.007-.694-1.621 0-3.273 1.34-4.032 2.912-.049-1.175-.404-2.66-1.631-2.66-.452 0-.815.026-1.152.084-.238.042-.462.121-.405.6.119 1.006.14 1.718.14 2.849V32.66c0 .224.068.366.392.422.311.053.7.085 1.152.085.452 0 .9-.032 1.21-.085.326-.056.394-.199.394-.422v-6.663c0-1.995.59-3.159 1.369-3.84 1.122-.978 2.383-.898 3.035-.898.243 0 .407-.047.488-.47.11-.579.095-1.255.047-1.781ZM87.198 18.314c-1.621 0-3.274 1.34-4.032 2.912-.05-1.175-.405-2.66-1.632-2.66-.452 0-.815.026-1.152.084-.238.042-.462.122-.405.6.12 1.006.14 1.718.14 2.849V32.66c0 .224.068.366.393.422.31.053.7.084 1.151.084.453 0 .9-.03 1.21-.084.327-.056.395-.198.395-.422v-6.664c0-1.994.588-3.158 1.368-3.839 1.122-.978 2.384-.898 3.036-.898.243 0 .407-.047.487-.47.11-.579.096-1.255.048-1.781-.056-.623-.608-.694-1.007-.694ZM53.104 18.314c-1.655 0-3.331.853-4.478 2.437-.582-1.512-1.85-2.437-3.924-2.437-1.534 0-3.144.74-4.263 2.11-.165-.956-.592-1.859-1.548-1.859-.453 0-.815.027-1.152.085-.239.042-.462.122-.406.6.12 1.006.14 1.718.14 2.849V32.66c0 .224.068.366.394.422.31.053.699.084 1.151.084.452 0 .9-.03 1.21-.084.326-.056.393-.198.393-.422V25.05c0-2.534 1.19-4.078 2.874-4.078 1.597 0 2.422 1.162 2.422 3.068v8.621c0 .224.067.366.392.422.31.053.727.084 1.18.084a7.24 7.24 0 0 0 1.178-.084c.325-.056.393-.198.393-.422V25.05c0-2.534 1.188-4.078 2.873-4.078 1.597 0 2.422 1.162 2.422 3.068v8.621c0 .224.068.366.393.422.31.053.726.084 1.178.084.452 0 .869-.03 1.18-.084.325-.056.392-.198.392-.422v-9.296c0-2.991-1.3-5.05-4.394-5.05ZM106.675 18.314c-1.503 0-2.967.759-4.14 2.09-.167-.947-.594-1.839-1.545-1.839a6.63 6.63 0 0 0-1.152.085c-.238.042-.462.122-.405.6.12 1.006.14 1.718.14 2.849V32.66c0 .224.068.366.393.422.31.053.7.085 1.152.085.452 0 .9-.032 1.21-.085.325-.056.393-.198.393-.422v-7.72c0-2.538 1.411-3.97 2.999-3.97 1.598 0 2.579 1.163 2.579 3.069v8.621c0 .224.068.367.393.422.309.053.726.085 1.179.085.452 0 .868-.032 1.179-.085.325-.055.392-.198.392-.422v-9.296c0-2.991-1.672-5.05-4.767-5.05Z",
    fill: "#511E62"
  }), _jsx("mask", {
    id: "logo-pi-simple_svg__d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 18,
    width: 13,
    height: 16,
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M113.664 18.314h11.963v14.853h-11.963V18.314Z",
      fill: "#fff"
    })
  }), _jsx("g", {
    mask: "url(#logo-pi-simple_svg__d)",
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M120.915 18.314c-1.503 0-2.967.759-4.14 2.09-.167-.947-.595-1.839-1.545-1.839-.452 0-.815.027-1.151.085-.239.042-.463.122-.406.6.12 1.006.14 1.718.14 2.849V32.66c0 .224.067.366.393.422.31.053.699.085 1.152.085.451 0 .899-.032 1.21-.085.325-.056.392-.198.392-.422v-7.72c0-2.538 1.411-3.97 3-3.97 1.597 0 2.579 1.163 2.579 3.069v8.621c0 .224.067.367.393.422.31.053.698.085 1.151.085.453 0 .841-.032 1.152-.085.325-.055.392-.198.392-.422v-9.296c0-2.991-1.618-5.05-4.712-5.05Z",
      fill: "#511E62"
    })
  })]
}));
export default SvgLogoPiSimple;